import { TSSOProviderName } from "@/types";

import { publicClient } from "./api";

class SSOServiceClass {
	handleSSOLoginFromProvider(provider: TSSOProviderName) {
		return publicClient.post(`/auth/${provider}`);
	}

	handleCallback() {
		return publicClient
			.get(`/auth/sso/callback`, {
				withCredentials: true,
			})
			.then((res) => res.data);
	}
}

const SSOService = new SSOServiceClass();
export default SSOService;
